import { CerFormAdapter } from '@form/cer-form-adapter';

import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';

export class VendorTransForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet) {
    viewSet.viewAdd(this.viewGet());
  }

  private viewGet(): CerFormView {
    
    const view = new CerFormView();

    view.viewMetadata = {
      name: 'vendor-trans', dataApiName: 'VendorTrans', text: 'Kreditorposteringer', textSingular: 'Kreditorpostering',
      primaryKey: 'id', titleFields: ['num','date','txt'], baseFields: ['id'],
      allowCreate: false, allowEdit: false, allowDelete: false,
      navigations: [{ link: 'nav', foreignKey: {entity: 'voucher', column: 'voucherNum', parentColumn: 'voucher'}}]
    };

    view.fieldMetadata = [
      { fieldType: 'vendor', name: 'num'},
      { fieldType: 'transDate', orderBy: 'Descending' },
      { name: 'voucher', text: 'Bilag' },
      { name: 'txt', text: 'Tekst' },
      { name: 'documentNum', text: 'Faktura' },
      { name: 'amountCur', text: 'Beløb', format: 'Amount' },
      { fieldType: 'currency' },
      { name: 'amountStd', text: 'Beløb DKK', format: 'Amount' },
      { name: 'active', text: 'Åbn', format: 'CheckBox' },
      { name: 'dueDate', text: 'Forfaldsdato', format: 'DateShort' },
      { fieldType: 'vendorTransType' }
    ];

    return view;
  }
}
